export default "__VITE_ASSET__Cj2W7Pc7__"